import React from 'react';

import { PrimaryButton, ProButton } from '@components/Button/variants';

import StepCounter from './StepCounter';

export interface StepNavigationProps {
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  stepCounterClassName?: string;
  totalSteps?: number;
}

const StepNavigation = ({
  handleNext,
  isProSubscriber,
  step,
  stepCounterClassName,
  totalSteps,
}: StepNavigationProps) => {
  const Button = isProSubscriber ? ProButton : PrimaryButton;

  return (
    <div className="mt-32 flex items-center gap-64">
      <StepCounter step={step} totalSteps={totalSteps} className={stepCounterClassName} />
      <Button as="button" size="small" className="w-full" onClick={handleNext}>
        Next
      </Button>
    </div>
  );
};

export default StepNavigation;
